import { defineNuxtPlugin } from '#app/nuxt';
import { isBlockSerialized, mapBlockDataToSerialized, mapSerializedToBlockData, setBlockAdapterResolver, useBlockLibraryStore } from '#layers/block-engine/public';
import { useWorkspaceRuntimeHandle } from '#layers/runtime/public';

/** Connects block adapters to the workspace runtime active when each consumer is created. */
export function registerBlockAdapterHandlers(): () => void {
	const blockLibrary = useBlockLibraryStore();

	return setBlockAdapterResolver(() => {
		const handle = useWorkspaceRuntimeHandle();

		return {
			async loadBlockSerialized(id) {
				const cached = handle.isActive() ? blockLibrary.getBlock(id) : undefined;
				if (isBlockSerialized(cached)) return cached;

				// The read lands in this runtime's cache, so the library derives the block if the runtime is still active.
				const block = await handle.store.MonospaceBlock.findFirst(id);
				return block ? mapBlockDataToSerialized(block) : undefined;
			},
			async saveBlockSerialized(block) {
				await handle.store.MonospaceBlock.update(mapSerializedToBlockData(block));
				if (handle.isActive()) blockLibrary.triggerBlockRefresh(block.id);
			},
		};
	});
}

export default defineNuxtPlugin(() => {
	const unregister = registerBlockAdapterHandlers();

	import.meta.hot?.dispose(unregister);
});
